import type { TypedCustomDatasource } from '../types';
import type { CustomDatasourceFormData } from './customDatasourceSchema';
import { mapServerDataToFormData } from './formDataMapping';

/**
 * Builds create-form default values from a source custom data source so the
 * create page opens pre-populated with everything except a fresh Title.
 *
 * The data-source tree, selected fields and filters are carried over via the
 * same server→form mapper the edit page uses. Title is blanked so the user must
 * name the copy. Id, creation date and audit metadata are excluded by
 * construction — they are not part of the form shape, so the save takes the
 * insert (create) branch and the new record is independent of the source.
 *
 * The result is deep-cloned so edits in the open form never mutate the cached
 * source; the form holds a snapshot taken when it opened.
 */
export const buildCopiedCustomDatasourceDefaults = (
  source: TypedCustomDatasource
): CustomDatasourceFormData =>
  structuredClone({ ...mapServerDataToFormData(source), title: '' });
